import { ReportBlockTypeApiEnum } from '@api/reports/enum/report-block-type-api.enum';
import { BlockModel } from '@Common/PageBuilder/models/block.model';
import { ChartDisplayElementModel } from '@Common/Reports/models/chart-display-element.model';
import { ReportsDataMappingKeysEnum } from '@Common/Reports/models/reports-block-mapping-configuration.model';


export function sharedReportDataFromTwoPointOneToTwoPointTwo(block: BlockModel, chartData: any): BlockModel {

    let data;
    const dataPoints = [];
    const displayElement = block.displayElement as ChartDisplayElementModel;

    if (block.type.key === ReportBlockTypeApiEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME) {
        displayElement.mapChartColorScheme = displayElement.mapChartColorScheme || displayElement.styles.mapChartColorScheme;
        displayElement.mapChartChoroplethInterpolationType = displayElement.mapChartChoroplethInterpolationType
            || displayElement.styles.mapChartChoroplethInterpolationType;
        data = displayElement.series[0].dataProvider.getValue();
        data.forEach(x => {
            dataPoints.push({
                id: x.id,
                label: x.label,
                mappingKeys: x.mappingKeys || {
                    [ReportsDataMappingKeysEnum.LOCATION]: x.id
                },
                value: x.value || x.xValue,
                percent: x.percent || x.yValue || 0
            });
        });
        displayElement.series[0].dataProvider.next(dataPoints);
    }

    block['version'] = '2.2';
    return block;
}
